import React, { useState } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { Box } from '@material-ui/core/';
import AdapterLink from '../common/adapterLink';
import AnyLink from '../common/anyLink';
import authService from '../../services/authService';
import { useMobile } from '../../hooks/utilHooks';
import { showActionButton } from '../../utils/postUtil';
import CardButtons from '../user/cardButtons';
import { initProfileButtons } from '../../utils/userUtil';
import { useProfileButtons } from '../../hooks/userDataHooks';

const PostAuthorInfo = ({
  post,
  isPostDetail,
  handleClick,
  handleClickOnCommunity,
}) => {
  const classes = useStyles();
  const isMobile = useMobile();
  const user = authService.getCurrentUser();
  const getCurrentUserId = user && user.id;
  const showButton = showActionButton(post, getCurrentUserId);
  const [showBtn, setShowBtn] = useState(initProfileButtons);
  const authorName = (
    <Typography
      variant="body2"
      component="span"
      color="textPrimary"
      className="removeUnderline"
    >
      {post && post.author && post.author.name ? post.author.name : ''}
    </Typography>
  );
  const {
    sayHiBtn,
    pendingBtn,
    followingBtn,
    followBtn,
    confirmTextBtn,
    addFriendBtn,
  } = useProfileButtons({
    isUserProfile: false,
    isFeed: true,
    userInfoObject: post,
    userId: post && post.authorId && post.authorId,
    setShowBtn,
    showBtn,
  });
  function handleAuthorName() {
    return post.userDeepLinkUrl || '/';
  }

  const getCommunityName = !post.isCommunityPost
    ? post.communityName
    : post.communityName + ' Posted';

  return (
    <React.Fragment>
      <Box width={isMobile ? 0.65 : 0.78} className={classes.mainBox}>
        {!post.isCommunityPost && (
          <Box onClick={handleClick} display="inline-block">
            {post &&
            post.author &&
            post.author.name &&
            post.author.name === 'Anonymous' ? (
              <Box display="inline-block">{authorName}</Box>
            ) : (
              <AnyLink to={handleAuthorName()}>{authorName}</AnyLink>
            )}
          </Box>
        )}
        {post && post.subType !== 'A' && (
          <span>
            {post.isWallPost || post.isPostOwnWall ? (
              <React.Fragment>
                <Typography variant="body1" component="span">
                  &nbsp;posted on
                </Typography>
                <Typography variant="body2" component="span">
                  &nbsp;her wall &nbsp;
                </Typography>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Box
                  display="block"
                  to={post.communitySlug || ''}
                  component={AdapterLink}
                  className="blackLink"
                >
                  <Typography
                    variant="overline"
                    onClick={handleClickOnCommunity}
                    component="span"
                  >
                    {post.communityId === 0
                      ? post.challengePostText + ' Challenge'
                      : getCommunityName}
                  </Typography>
                </Box>
              </React.Fragment>
            )}
          </span>
        )}
      </Box>

      {post && showButton && !post.isRequestSent && (
        <Box className="floatRight">
          <CardButtons
            userInfoObject={post}
            userId={post.authorId && post.authorId}
            isFeed={true}
            showBtn={showBtn}
            setShowBtn={setShowBtn}
            sayHiBtn={sayHiBtn}
            pendingBtn={pendingBtn}
            followingBtn={followingBtn}
            followBtn={followBtn}
            confirmTextBtn={confirmTextBtn}
            addFriendBtn={addFriendBtn}
          />
        </Box>
      )}
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  mainBox: {
    verticalAlign: 'sub',
    display: 'inline-block',
  },
  followBtn: {
    borderRadius: theme.spacing(6),
    fontSize: theme.spacing(3),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
}));

export default PostAuthorInfo;
